package pl.nickers.match3.ecs

internal class MatchNeighbourCleanupSystem : BaseSystem() {
    private lateinit var matchNeighbourMapper: ComponentMapper<MatchNeighbourComponent>
    private lateinit var hitByAreaEffectMapper: ComponentMapper<HitByAreaEffectComponent>

    override fun initialize() {
        matchNeighbourMapper = world.mapper()
        hitByAreaEffectMapper = world.mapper()
    }

    override fun processSystem() {
        val board = world.boardState() ?: return
        if (board.phase != GamePhase.INPUT) return
        world.getEntitiesForAspect(Aspect.all(MatchNeighbourComponent::class))
            .toList()
            .forEach { matchNeighbourMapper.remove(it) }
        world.getEntitiesForAspect(Aspect.all(HitByAreaEffectComponent::class))
            .toList()
            .forEach { hitByAreaEffectMapper.remove(it) }
    }
}
